<script setup>
import {computed, onMounted, ref} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ProgressBar from 'primevue/progressbar';
import Toast from 'primevue/toast';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Textarea from 'primevue/textarea';
import { loadAvaliacoesDosEstudantesNoPlano, loadEstudantesDaTurma } from '@/api/fetchEstudantes';
import { loadPlanoPorId } from '@/api/fetchPlanos';
import HeaderDetailsPage from '@/components/layout/HeaderDetailsPage.vue';
const router = useRouter();
const route = useRoute();

const loadingHeader = ref(false);
const estudantesDaTurma = ref([]);
const estudanteSelecionado = ref();
const idDoPlano = ref(null);
const idDaTurma = ref(null);
const idDaAula = ref(null)

const criterioAvaliacaoDoPlano = ref([]);
const avaliacoesDosEstudantes = ref([]);
const introducaoMensagemFeedback = ref('Olá. Veja abaixo quais níveis da rubrica de avaliação que você alcançou em nosso último plano de aula, sobre as áreas da filosofia. Se ficar com alguma dúvida, converse comigo em aula para esclarecer.');
const mensagemFeedback = computed(() => {
    if (!estudanteSelecionado.value) return;
    return feedbacks.value.find(item => item.estudanteId === estudanteSelecionado.value);
});
const feedbacks = ref([]);

function goBack() {
    router.go(-1)
}


onMounted(async() => {
    loadingHeader.value = true;
    if (!route.query.idDaTurma || !route.query.idDaAula || !route.query.idDoPlano){
        router.go(-1);
    }

    idDaTurma.value = route.query.idDaTurma;
    idDaAula.value = route.query.idDaAula;
    idDoPlano.value = route.query.idDoPlano;

    estudantesDaTurma.value = await loadEstudantesDaTurma(idDaTurma.value);
    criterioAvaliacaoDoPlano.value = await loadPlanoPorId(idDoPlano.value);
    avaliacoesDosEstudantes.value = await loadAvaliacoesDosEstudantesNoPlano(estudantesDaTurma.value.map(item => item.id), criterioAvaliacaoDoPlano.value.map(item => item.id));
    
    loadingHeader.value = false;
    estudanteSelecionado.value = estudantesDaTurma.value[0].id;
    criarFeedback();
    
})

function criarFeedback(){
    feedbacks.value = [];
    estudantesDaTurma.value.forEach(estudante => {
        const feedback = gerarFeedback(estudante);
        const localFeedabcks = []
        if (feedback) {
            localFeedabcks.push({ estudanteId: estudante.id, email: estudante.email_teams, feedback: feedback });
        }

        feedbacks.value = [...feedbacks.value, ...localFeedabcks];
    });
}

function gerarFeedback(estudante){
    const avaliacoes = avaliacoesDosEstudantes.value.filter(item => item.estudante === estudante.id && item.nota > 0 && item.nota <= 100);

    if(avaliacoes.length === 0){
        return '';
    }
    const avaliacoesAB = gerarTextoCriterios(avaliacoes.filter(item => item.nota < 60), 'atingiu minimamente ', '⚠️');
    const avaliacoesB = gerarTextoCriterios(avaliacoes.filter(item => item.nota >= 60 && item.nota < 80), 'atingiu parcialmente ', '⚠️');
    const avaliacoesAD = gerarTextoCriterios(avaliacoes.filter(item => item.nota >= 80 && item.nota < 100), 'atingiu plenamente ', '✅');
    const avaliacoesAV = gerarTextoCriterios(avaliacoes.filter(item => item.nota === 100), 'excedeu as expectativas n', '✅');

    let mensagem = introducaoMensagemFeedback.value + '\n\n';
    
    if(avaliacoesAV){
        mensagem += avaliacoesAV + '\n\n';
    }

    if(avaliacoesAD){
        mensagem += avaliacoesAD + '\n\n';
    }

    if(avaliacoesB){
        mensagem += avaliacoesB + '\n\n';
    }

    if(avaliacoesAB){
        mensagem += avaliacoesAB;
    }

    return mensagem;
   
}

function replaceNPorBr(mensagem){
    return mensagem.replaceAll('\n', '<br>');
}

function gerarTextoCriterios(avaliacoes, nivel, emoji){
    if(avaliacoes.length === 0) return false;
    let mensagem = '';
    if(avaliacoes.length > 1){
        mensagem = `${emoji} Você ${nivel}os seguintes critérios do plano: \n`;  
    }else{
        mensagem = `${emoji} Vocé ${nivel}o seguinte critério do plano: \n`;
    }
    

    avaliacoes.forEach(item => {
       const nivelAdequado = criterioAvaliacaoDoPlano.value.find(criterio => criterio.id == item.avaliacao).nivel3;
        mensagem += `- ${nivelAdequado} \n`;
    })
    return mensagem
}


function exportarFeedbacksComoCSV() {
    if (!Array.isArray(feedbacks.value) || feedbacks.value.length === 0) {
        console.warn("A lista de feedbacks está vazia ou não é válida.");
        return;
    }

    // Criar o cabeçalho do CSV
    let csvContent = "Email,Feedback\n";

    // Formatar os dados
    feedbacks.value.forEach(({ email, feedback }) => {
        // Substituir aspas duplas dentro do texto para não quebrar o formato CSV
        let feedbackFormatado = feedback.replace(/"/g, '""');

        // Adicionar aspas duplas para preservar quebras de linha dentro da célula do Excel
        csvContent += `${email},"${feedbackFormatado}"\n`;
    });

    // Criar um blob com os dados do CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Criar um link para baixar o arquivo
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "feedbacks.csv");
    document.body.appendChild(link);
    link.click();

    // Remover o link da página após o download
    document.body.removeChild(link);
}



</script>

<template>
    <HeaderDetailsPage :loading="loadingHeader" titulo="Voltar" />
    <div style="margin-top: 60px;">

        <div class="p-3" style="max-width: 800px; margin: 0 auto;">

            <Dropdown v-model="estudanteSelecionado" :options="estudantesDaTurma" optionLabel="nome" optionValue="id"
                placeholder="Selecione um estudante" class="w-full" />
            <div class="mt-3">
                <label class="text-color-secondary text-sm">Introdução do feedback</label>
                <Textarea @input="criarFeedback" autoResize cols="30" rows="3" v-model="introducaoMensagemFeedback"
                    class="w-full mt-2"
                    placeholder="Exemplo de mensagem de introdução: Olá. Veja abaixo quais níveis da rubrica de avaliação você atingiu em nosso último plano de aula, sobre as áreas da filosofia. Se ficar com alguma dúvida, converse comigo em aula para esclarecer." />
            </div>
            <div class="mt-3 flex justify-content-end gap-2">
                <Button label="Exportar feedbacks" @click="exportarFeedbacksComoCSV" />
            </div>

            <div v-if="mensagemFeedback" class="mt-5">
                <div class="bg-white shadow-1 border-round-md p-4">
                    <h3>Feedback</h3>
                    <div v-html="replaceNPorBr(mensagemFeedback.feedback)"></div>
                </div>
            </div>
            <div v-else>
                <p v-if="estudanteSelecionado">Esse estudante não tem nenhuma avaliação nesse plano.</p>
            </div>
        </div>
    </div>
</template>